import { IconButton, Label, MessageBarType, Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { containerStyles, formContainerStyles, innerTitleStyles, lgContainerStyles, lgInnerTitleStyles, lgSubContainerStyles, lgSubInnerTitleStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdInnerTitleStyles, mdSubContainerStyles, mdSubInnerTitleStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smInnerTitleStyles, smSubContainerStyles, smSubInnerTitleStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subContainerStyles, subInnerTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlInnerTitleStyles, xlSubContainerStyles, xlSubInnerTitleStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlInnerTitleStyles, xxlSubContainerStyles, xxlSubInnerTitleStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../../Common/Styles/CommonStyles";
import { useRegisterContext } from "../../../RegisterContainer";
import { useContext, useEffect, useState } from "react";
import { RegisterTextField } from "../../Common/RegisterField";
import { formCredentialsContainerStyles, iconSuffixStyles, lgPasswordLabelStyles, mdFormCredentialsContainerStyles, mdPasswordLabelStyles, passwordLabelStyles, smFormCredentialsContainerStyles, smPasswordLabelStyles, xlPasswordLabelStyles, xxlPasswordLabelStyles } from "./Styles/RegisterTrialAdminStyles";
import { RegisterService } from "../../../Service/RegisterService";
import { Trans } from "react-i18next";
import { RegisterSecondaryButton } from "../../Common/RegisterButton";
import { ISessionStateContext, SessionStateContext } from "../../../../../../Core/State/SessionStateContext";
import { RegisterMessageBar } from "../../Common/RegisterErrorBar";

export const RegisterTrialAdmin: React.FC = () => {
    const registerContext = useRegisterContext();
    const [adminUser] = useState<string>(registerContext.leadToLive.adminUser.userPrincipleName);
    const [showDescription, setShowDescription] = useState<boolean>(false);
    const [sendEmailVisible, setSendEmailVisible] = useState<boolean>(false);
    const [messageBarVisible, setMessageBarVisible] = useState<boolean>(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info);
    const sessionInfoContext: ISessionStateContext = useContext(SessionStateContext);
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    const copyUsername = () => {   
        navigator.clipboard.writeText(adminUser).then(()=>{
            setShowDescription(true);
        })
    };

    const handleShowSendEmail = () => {
        window.setTimeout(() => {
            setSendEmailVisible(true);
        }, 8000);
    };

    const handleSendEmail = () => {
        setMessageBarVisible(true);
        RegisterService.sendCredentialEmail(sessionInfoContext.currentUser.userId).then(() => {
            setMessageBarType(MessageBarType.success);
        })
        .catch(() => {
            setMessageBarType(MessageBarType.error);
        });
    };

    useEffect(() => {
        registerContext.setFooterButtonProps({
            ...registerContext.footerButtonProps,
            backButtonDisabled: false,
            nextButtonDisabled: false,
            nextButtonHidden: false,
            nextButtonText: RegisterService.translate("trialAdmin:loginButton"), 
            nextButtonIcon: "WindowsLogo",
            nextButtonReverseFlex: true
        });

        handleShowSendEmail();
    }, []);

    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("trialAdmin:title")}
                </Text>
                <Text 
                    className={
                        isSM ? 
                            smSubTitleStyles : 
                        isMD ? 
                            mdSubTitleStyles :
                        isLG ?
                            lgSubTitleStyles :
                        isXL ?
                            xlSubTitleStyles :
                        isXXL ?
                            xxlSubTitleStyles
                        :
                            subTitleStyles
                    }
                >
                    <Trans 
                        i18nKey={"common:register:trialAdmin:description"}
                        components={[<strong />]}
                    />
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
                horizontal
                horizontalAlign="center"
            >
                <Stack
                    className={isSM ? smFormCredentialsContainerStyles : isMD ? mdFormCredentialsContainerStyles : formCredentialsContainerStyles}
                >
                    <RegisterTextField 
                        readOnly
                        placeholder={RegisterService.translate("trialAdmin:userName")}
                        value={adminUser}
                        label={RegisterService.translate("trialAdmin:userName")}
                        description={showDescription ? RegisterService.translate("trialAdmin:copyText") : ""}
                        onChange={() => {}}
                        onRenderSuffix={() => {
                            return (
                                <IconButton
                                    styles={iconSuffixStyles}
                                    iconProps={{ iconName: "Copy" }}
                                    onClick={() => copyUsername()}
                                />
                            );
                        }}
                    />
                    <Label
                        className={
                            isSM ? 
                                smPasswordLabelStyles : 
                            isMD ? 
                                mdPasswordLabelStyles : 
                            isLG ?
                                lgPasswordLabelStyles :
                            isXL ?
                                xlPasswordLabelStyles :
                            isXXL ?
                                xxlPasswordLabelStyles 
                            :
                                passwordLabelStyles
                        }
                    >
                        {RegisterService.translate("trialAdmin:infoText", {email: registerContext.leadToLive.lead.email})}
                    </Label>
                </Stack>
            </Stack>
            <Stack
                hidden={!sendEmailVisible}
                className={
                    isSM ? 
                        smSubContainerStyles : 
                    isMD ? 
                        mdSubContainerStyles :
                    isLG ?
                        lgSubContainerStyles :
                    isXL ?
                        xlSubContainerStyles :
                    isXXL ?
                        xxlSubContainerStyles
                    :
                        subContainerStyles
                }
            >
                <Stack
                    className={
                        isSM ? 
                            smTitleContainerStyles : 
                        isMD ? 
                            mdTitleContainerStyles :
                        isLG ?
                            lgTitleContainerStyles :
                        isXL ?
                            xlTitleContainerStyles :
                        isXXL ?
                            xxlTitleContainerStyles
                        :
                            titleContainerStyles
                    }
                >
                    <Stack
                        className={
                            isSM ? 
                                smTitleContainerStyles : 
                            isMD ? 
                                mdTitleContainerStyles :
                            isLG ?
                                lgTitleContainerStyles :
                            isXL ?
                                xlTitleContainerStyles :
                            isXXL ?
                                xxlTitleContainerStyles
                            :
                                titleContainerStyles
                        }
                    >
                        <Text 
                            className={
                                isSM ? 
                                    smInnerTitleStyles : 
                                isMD ? 
                                    mdInnerTitleStyles : 
                                isLG ?
                                    lgInnerTitleStyles :
                                isXL ?
                                    xlInnerTitleStyles :
                                isXXL ?
                                    xxlInnerTitleStyles
                                :
                                    innerTitleStyles
                            }
                        >
                            {RegisterService.translate("trialAdmin:sendTemporaryTitle")}
                        </Text>
                        <Text 
                            className={
                                isSM ? 
                                    smSubInnerTitleStyles : 
                                isMD ? 
                                    mdSubInnerTitleStyles :
                                isLG ?
                                    lgSubInnerTitleStyles :
                                isXL ?
                                    xlSubInnerTitleStyles :
                                isXXL ?
                                    xxlSubInnerTitleStyles
                                :
                                    subInnerTitleStyles
                            }
                        >
                            {RegisterService.translate("trialAdmin:sendTemporaryDescription")}
                        </Text>
                    </Stack>
                    <Stack
                        className={formContainerStyles}
                    >
                        <RegisterSecondaryButton 
                            iconName="Mail"
                            infoText=""
                            text={RegisterService.translate("trialAdmin:sendTemporaryButton")}
                            onClick={() => {handleSendEmail()}}
                        />
                        <RegisterMessageBar 
                            message={
                                messageBarType === MessageBarType.info ?
                                    RegisterService.translate("trialAdmin:credentialsLoader")
                                :
                                messageBarType === MessageBarType.success ?
                                    RegisterService.translate("trialAdmin:credentialsSuccess")
                                :
                                messageBarType === MessageBarType.error ?
                                    RegisterService.translate("trialAdmin:credentialsError")
                                :
                                    ""
                            }
                            type={messageBarType}
                            visible={messageBarVisible}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};